var _path, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.48842 5.22104C5.31767 4.79416 5.76504 4.38252 6.17626 4.58813L12.1056 7.55279C12.4741 7.73705 12.4741 8.26295 12.1056 8.44721L6.17626 11.4119C5.76504 11.6175 5.31767 11.2058 5.48842 10.779L5.75726 10.1069C5.78538 10.0365 5.82912 9.97353 5.88516 9.92258L7.59303 8.36997C7.81125 8.17159 7.81125 7.82841 7.59303 7.63003L5.88516 6.07742C5.82912 6.02647 5.78538 5.96346 5.75726 5.89314L5.48842 5.22104Z",
    fill: "#002A69"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 7.5,
    width: 3,
    height: 1,
    rx: 0.5,
    fill: "#002A69"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 5.5,
    width: 2,
    height: 1,
    rx: 0.5,
    fill: "#002A69"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 9.5,
    width: 2,
    height: 1,
    rx: 0.5,
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSent);
export default __webpack_public_path__ + "static/media/Sent.182a6d766ae6becaf2c21ae0354b5e22.svg";
export { ForwardRef as ReactComponent };